// extracted by mini-css-extract-plugin
module.exports = {"flag":"Flag_flag__T1D9s"};